const { showError, showNotifikasi } = require('../libs/helper');

module.exports = {
    upload: async (g, data) => {
        await g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'sensus-pengguna/store-sptjm',
            method: 'post',
            data,
        })
            .then(res => {
                try {
                    if (res.data.code == 400 || res.data.code == 401 || res.data.code == 403)
                        showNotifikasi(g, 'danger', 'Error Upload', res.data.message)
                } catch (error) {
                    console.log(error);
                }
            })
            .catch(err => {
                showError(g, err, `Error Submit Form`)
            })
    },
    getData: async (g, params) => {
        const result = await g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'sensus-pengguna/get-list-sptjm',
            params
        })
            .then(res => {
                return res.data
            })
            .catch(err => {
                showError(g, err, `Error Get Data`)
            })
        return result;
    },
}